import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SettingsService } from 'lib-shared';
import { lastValueFrom } from 'rxjs';
import {
  ApiResponse,
  AuthService,
  MY_ACCOUNT_CONFIG,
} from '../../../public-api';

@Injectable({
  providedIn: 'root',
})
export class PackagePriceService {
  private config = inject(MY_ACCOUNT_CONFIG);
  private authService = inject(AuthService);

  constructor(private http: HttpClient, private settings: SettingsService) {}

  // async getPackagePrice<T>(packageData: any) {
  //   const res = this.http.post<ApiResponse<T>>(`${this.settings.getHubBaseUrlApi}/${this.config.controllerApiList.HubApi.VnumberApi.GetPackagePrice}`, packageData );
  //   const data = await lastValueFrom(res);
  //   return data;
  // }

  // async getMyAccountPackagePrice<T>() {
  //   let headers = new HttpHeaders();
  //   const suspendedToken = this.validateSuspendedPayment();

  //   if (suspendedToken.status === false) {
  //     headers = new HttpHeaders().set(
  //       'authorization',
  //       `Bearer ${suspendedToken.token}`
  //     );
  //   }
  //   const res = this.http.get<ApiResponse<T>>(
  //     `${this.settings.getHubBaseUrlApi}/${this.config.controllerApiList.HubApi.VnumberApi.GetMyAccountPackagePrice}`,
  //     { headers: headers }
  //   );
  //   const data = await lastValueFrom(res);
  //   return data;
  // }

    async getMyAccountPackagePrice<T>() {
      const res = this.http.get<ApiResponse<T>>(`${this.settings.getHubBaseUrlApi}/${this.config.controllerApiList.HubApi.VnumberApi.GetMyAccountPackagePrice}` );
      const data = await lastValueFrom(res);
      return data;
    }

  async sendRenewalPackageId<T>(packageId: number) {
    let params = new HttpParams().set('renewalPriceId', packageId);

    const res = this.http.post<ApiResponse<T>>
    (`${this.settings.getHubBaseUrlApi}/${this.config.controllerApiList.HubApi.VnumberApi.RenewalPackageId}?${params}`, {});
    const data = await lastValueFrom(res);
    return data;
  }

  validateSuspendedPayment(): { status: boolean; token: string | null } {
    const isLoggedIn = this.authService.IsLogin();

    if (isLoggedIn) {
      return { status: true, token: null };
    } else if (this.authService.isSuspended()) {
      return { status: false, token: this.authService.getSuspendedToken() };
    }

    return { status: false, token: null };
  }
}
